import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import SelectPlaceholder from '/@/components/my-recommendations/select-placeholder';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { generateOptionsKeyValue } from '/@/utils';
import Select from '/@/v3/components/forms/select';
import Title from '/@/v3/components/title';
import styles from '../styles.module.css';

const MyRecommendationsMobileFilter = ({ recommendations, filterRecos, onChangeFilters }) => {
    const applyFilter = (filter, value) => {
        onChangeFilters({
            ...filterRecos,
            [filter]: value,
        });
    };

    useEffect(() => {
        onChangeFilters(filterRecos);
    }, [filterRecos]);

    return (
        <Grid container justifyContent='center' spacing={2}>
            <Grid item xs={11}>
                <Title className={styles.titleMyRecos}>{_('Filtros')}</Title>
            </Grid>
            <Grid item xs={11}>
                <Select
                    size='md'
                    color={settings.app.theme}
                    value={filterRecos['type']}
                    options={generateOptionsKeyValue('type', recommendations)}
                    onChange={(v) => applyFilter('type', v)}
                    placeholder={_('Tipo')}
                    clearable
                    maxHeight='200px'
                />
            </Grid>
            <Grid item xs={11}>
                <Select
                    size='md'
                    color={settings.app.theme}
                    value={filterRecos['created']}
                    options={generateOptionsKeyValue('created', recommendations)}
                    onChange={(v) => applyFilter('created', v)}
                    placeholder={<SelectPlaceholder text='Creación' />}
                    compact
                    clearable
                    maxHeight='200px'
                />
            </Grid>
            <Grid item xs={11}>
                <Select
                    size='md'
                    color={settings.app.theme}
                    value={filterRecos['plantingDate']}
                    options={generateOptionsKeyValue('plantingDate', recommendations)}
                    onChange={(v) => applyFilter('plantingDate', v)}
                    placeholder={<SelectPlaceholder text='Siembra' />}
                    compact
                    clearable
                    maxHeight='200px'
                />
            </Grid>
            <Grid item xs={11}>
                <Select
                    size='md'
                    color={settings.app.theme}
                    value={filterRecos['fieldName']}
                    options={generateOptionsKeyValue('fieldName', recommendations)}
                    onChange={(v) => applyFilter('fieldName', v)}
                    placeholder={_('Lote')}
                    clearable
                    maxHeight='200px'
                />
            </Grid>
            <Grid item xs={11}>
                <Select
                    size='md'
                    color={settings.app.theme}
                    value={filterRecos['environment']}
                    options={generateOptionsKeyValue('environment', recommendations)}
                    onChange={(v) => applyFilter('environment', v)}
                    placeholder={_('Ambiente')}
                    clearable
                    maxHeight='200px'
                />
            </Grid>
            <Grid item xs={11}>
                <Select
                    size='md'
                    color={settings.app.theme}
                    value={filterRecos['product']}
                    options={generateOptionsKeyValue('product', recommendations)}
                    onChange={(v) => applyFilter('product', v)}
                    placeholder={_('Producto')}
                    clearable
                    maxHeight='200px'
                />
            </Grid>
        </Grid>
    );
};

export default MyRecommendationsMobileFilter;
